module.exports = __webpack_public_path__ + "static/media/kumpulbaca-final-logo-hole.3ab4a8fe.png";